import { billingTransferRequestRoute } from "@common/constants/domains/billing/billingTransferRequest";
import { AcceptOrgBillingTransferReturn } from "@components/billing/OrgBillingTransfer/AcceptOrgBillingTransferReturn";
import { ORG_BILLING_TRANSFER_RETURN_PATH } from "@components/billing/OrgBillingTransfer/orgBillingTransferReturn.lib";
import { BillingTransferResolution } from "@components/billingTransfer/BillingTransferResolution";
import { Route } from "react-router-dom";

export function useRenderBillingTransferRoutes() {
    return (
        <>
            <Route
                path={billingTransferRequestRoute}
                element={<BillingTransferResolution />}
            />
            <Route
                path={ORG_BILLING_TRANSFER_RETURN_PATH}
                element={<AcceptOrgBillingTransferReturn />}
            />
        </>
    );
}
